export default "__VITE_ASSET__hcjVSQgV__"